interface SectionIndexProps {
  value: string
}

export function SectionIndex({ value }: SectionIndexProps) {
  return (
    <span className="section-index" aria-hidden="true">
      <span className="section-index__rule" />
      {value}
    </span>
  )
}
